import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../../../contexts/SystemSettingsContext';
import { GetPropertyTotals } from '../../../../../services/CampaignsDataService';
import { AirtimePlanningContext } from '../../../../../contexts/AirtimePlanningContext';

const TotalRow = ({ bodyCellStyle, dataStyle }) => {
    const { propertyStats, propertyTotals } = useContext(AirtimePlanningContext);
    const { formatCurrency, dateFormat, formatNumber } = useContext(SystemSettingsContext);

    const sumAllLines = (field) => {
        let total = 0;
        if (propertyStats?.length) {
            propertyStats?.forEach((b) => {
                if (b !== undefined) {
                    total = total + (b[field] !== undefined ? parseFloat(b[field] ?? 0) : 0);
                }
            });
        }
        return total;
    };
    const sumAllLinesScheduledContent = () => {
        let total = 0;
        if (propertyStats?.length) {
            propertyStats?.forEach((b) => {
                if (b !== undefined) {
                    if (b.sandPPropertyTypeName === 'Ongoing') {
                        if (b.hasVariance || b?.isUpdated || (b?.id && b?.id !== window.emptyGuid)) {
                            total += b?.scheduledContentCalcedSpots + b?.airtimeCalcedSpots ?? 0;
                        } else {
                            total += (b.scheduledContentSpotCount + b?.airtimeSpotCount) * b?.weeks;
                        }
                    } else {
                        total += b?.scheduledContentCalcedSpots + b?.airtimeCalcedSpots ?? 0;
                    }
                }
            });
        }
        return total;
    };
    const sumAllLinesLiveContent = () => {
        let total = 0;
        if (propertyStats?.length) {
            propertyStats?.forEach((b) => {
                if (b !== undefined) {
                    if (b.sandPPropertyTypeName === 'Ongoing') {
                        if (b.hasVariance || b?.isUpdated || (b?.id && b?.id !== window.emptyGuid)) {
                            total += b?.featureCalcedSpots ?? 0;
                        } else {
                            total +=
                                (b?.featureSpotCount !== undefined ? parseFloat(b?.featureSpotCount ?? 0) : 0) *
                                b.weeks;
                        }
                    } else {
                        total += b?.featureCalcedSpots !== undefined ? parseFloat(b?.featureCalcedSpots ?? 0) : 0;
                    }
                }
            });
        }
        return isNaN(total) ? 0 : total;
    };
    const sumAllLinesUsingWeeks = (field) => {
        let total = 0;
        if (propertyStats?.length) {
            propertyStats?.forEach((b) => {
                if (b !== undefined) {
                    if (b.sandPPropertyTypeName === 'Ongoing') {
                        console.log(':sumSpots ', b);
                        if ((b.hasVariance || b?.isUpdated) && b?.hasOwnProperty('totalCalcedSpots')) {
                            total += b?.totalCalcedSpots;
                        } else {
                            total += (b[field] !== undefined ? parseFloat(b[field] ?? 0) : 0) * b.weeks;
                        }
                    } else {
                        total += b[field] !== undefined ? parseFloat(b[field] ?? 0) : 0;
                    }
                }
            });
        }
        return total;
    };

    const sumListPrice = () => {
        let total = 0;
        if (propertyStats?.length) {
            propertyStats?.forEach((b) => {
                if (b !== undefined) {
                    total += b?.propertyListPrice !== undefined ? parseFloat(b?.propertyListPrice ?? 0) : 0;
                }
            });
        }
        return total;
    };

    const sumTotalImpacts = () => {
        let total = 0;
        if (propertyStats?.length) {
            propertyStats?.forEach((b) => {
                if (b !== undefined) {
                    total += b?.totalImpacts !== undefined ? parseFloat(b?.totalImpacts ?? 0) : 0;
                }
            });
        }
        return total;
    };

    const calculatedDealPrice = (selectedProperty) => {
        return selectedProperty.propertyDealPrice ?? 0;
    };

    const sumAllLinesDealPrice = () => {
        let total = 0;
        if (propertyStats?.length) {
            propertyStats?.forEach((b) => {
                if (b !== undefined) {
                    total += calculatedDealPrice(b);
                }
            });
        }
        return total;
    };
    return (
        <tfoot>
            <tr
                style={{
                    ...bodyCellStyle
                }}
            >
                <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>
                    <div style={{ display: 'flex' }}>
                        <div
                            style={{
                                width: 40,
                                height: '100%',
                                borderRight: 'none',
                                borderTop: 'none',
                                paddingTop: 7
                            }}
                        />
                        <div
                            style={{
                                width: 40,
                                height: 32,
                                borderLeft: '1px solid #D7D7D7',
                                borderRight: 'none',
                                borderTop: 'none',
                                paddingTop: 7
                            }}
                        />
                    </div>
                </td>
                <td style={{ ...dataStyle, minWidth: 220, maxWidth: 220 }}>{window.translate('Total')}</td>
                <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                <td style={{ ...dataStyle, minWidth: 60, maxWidth: 60 }}>&nbsp;</td>
                <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                <td style={{ ...dataStyle, minWidth: 100, maxWidth: 100 }}>
                    {formatNumber(propertyTotals?.totalScheduledSpotCount)}
                </td>
                <td style={{ ...dataStyle, minWidth: 100, maxWidth: 100 }}>{formatNumber(propertyTotals?.totalLiveSpotCount)}</td>
                <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>
                    {formatNumber(propertyTotals?.totalReach, { maximumFractionDigits: 0 })}
                </td>
                <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}> {/* ASSP-6668 */}
                    {formatNumber(
                        isNaN(100 * (propertyTotals?.totalReach / propertyTotals?.totalPopulation))
                          ? 0
                          : 100 * (propertyTotals?.totalReach / propertyTotals?.totalPopulation),
                        { maximumFractionDigits: 2 }
                      )
                    }
                </td>
                <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>
                    {formatNumber(propertyTotals?.totalImpacts, { maximumFractionDigits: 0 })}
                </td>
                <td style={{ ...dataStyle, minWidth: 70, maxWidth: 70 }}>
                    {formatNumber(
                        isNaN(propertyTotals?.totalImpacts / propertyTotals?.totalReach) ? 0 : propertyTotals?.totalImpacts / propertyTotals?.totalReach,
                        { maximumFractionDigits: 1 }
                    )}
                </td>
                <td style={{ ...dataStyle, minWidth: 110, maxWidth: 110 }}>
                    {formatCurrency(propertyTotals?.totalOffAirCosts, { maximumFractionDigits: 0 })}
                </td>
                <td style={{ ...dataStyle, minWidth: 140, maxWidth: 140 }}>
                    {formatCurrency(propertyTotals?.totalListPrice, { maximumFractionDigits: 0 })}
                </td>
                <td style={{ ...dataStyle, minWidth: 140, maxWidth: 140 }}>
                    {formatCurrency(propertyTotals?.totalDealPrice, { maximumFractionDigits: 0 })}
                </td>
                <td style={{ ...dataStyle, minWidth: 147, maxWidth: 147 }}>
                    {formatCurrency(parseFloat(propertyTotals?.totalSandPBudget), { maximumFractionDigits: 2 })}
                </td>
            </tr>
        </tfoot>
    );
};
export default TotalRow;
